import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './OffersPage.css';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { Category as CategoryModel, Product } from './models/models';
import Category from './components/Category';
import Spinner from './components/Spinner';
import data from './offers.json'; 

function Offers() {
    let { number } = useParams();
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const {balance , limit, first} = useOutletContext();
    const limitReached = limit && !limit.isNaN && !balance.isNaN && Number(limit) !== 0 && Number(limit) - Number(balance) <= 0 ;
    let rest = 0
    if (limit && !isNaN(limit) && Number(limit) !== 0) {
        rest = Number(limit) - Number(balance);
    }
    const [expandedCategoryId, setExpandedCategoryId] = useState(null);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    
    if (number) {
        number = "212" + number.slice(1);
    }
    
    // Handle category expansion
    const handleToggleExpand = (categoryId) => {
        setExpandedCategoryId(prevId => prevId === categoryId ? null : categoryId);
    };
    
    // Handle product selection
    const handleSelectProduct = (productId, product, categoryId) => {
        setSelectedProductId(prevId => prevId === productId ? null : productId);
        setSelectedProduct(prevProduct => prevProduct?.productId === product.productId ? null : product);
        
        // Ensure the category containing the selected product is expanded
        if (expandedCategoryId !== categoryId) {
            setExpandedCategoryId(categoryId);
        }
    };
    
    // Handle purchase button click
    const handlePurchase = () => {
        console.log("Selected product for purchase:", selectedProduct);
        if (!selectedProduct) return;
        
        // Create a formatted message with all product details
        const productDetails = `
    ** المرجوا التـأكد قبل الدفع فلا يوجد تعويض على الخطأ **
    الاسم: ${selectedProduct.productName}
    السعر: ${selectedProduct.finalPrice} درهم
    الصلاحية: ${selectedProduct.validity} أيام

    سيتم شحن الرقم: ${number.replace("212","0")}

    هل تريد متابعة عملية الشراء؟
        `;
        
        // Show confirmation alert
        if(window.confirm(productDetails)) {
            // Navigate to payment page with product details
            navigate('/payment', { 
                state: { 
                    product: selectedProduct,
                    phoneNumber: number
                } 
            });
        }
    };

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                setLoading(true);
                
                // Configure headers for Inwi API
                const headers = {
                    'Accept': '*/*',
                    'Accept-Language': 'fr-FR,fr;q=0.9,en-US;q=0.8,en;q=0.7',
                    'Connection': 'keep-alive',
                    'Origin': 'https://inwi.ma',
                    'Referer': 'https://inwi.ma/',
                    'Sec-Fetch-Dest': 'empty',
                    'Sec-Fetch-Mode': 'cors',
                    'Sec-Fetch-Site': 'same-site',
                    'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36',
                    'sdata': 'eyJjaGFubmVsIjoid2ViIiwiYXBwbGljYXRpb25fb3JpZ2luIjoibXlpbndpIiwidXVpZCI6ImUyMGI1MDgxLTc4MGMtNDQwNS1hZjE1LTNlNmRkN2MzOGYxNyIsImxhbmd1YWdlIjoiZnIiLCJhcHBWZXJzaW9uIjoxfQ==',
                    'sec-ch-ua': '"Chromium";v="134", "Not:A-Brand";v="24", "Google Chrome";v="134"',
                    'sec-ch-ua-mobile': '?0',
                    'sec-ch-ua-platform': '"Windows"',
                };

                // Call the Inwi API
                const response = await axios.get(`https://rechargemoi.ma/backend/storage/offers.json`, {
                    // params: { gzip_controle: 'true' },
                    // headers: headers
                });
                // const response = await axios.get(`https://api.inwi.ma/api/v1/ms-catalog/recharge/${number}`, {
                //     params: { gzip_controle: 'true' },
                //     headers: headers
                // });

                // Process the data to match our models
                if (response.data) {
                    const parsedCategories = parseApiData(response.data);
                    setCategories(parsedCategories);
                    // // Auto-expand the first category if available
                    // if (parsedCategories.length > 0) {
                    //     setExpandedCategoryId(parsedCategories[0].catId);
                    // }
                } else {
                    setCategories([]);
                }
                
                setLoading(false);
            } catch (err) {
                console.error("Error fetching offers:", err);
                setError("Failed to load offers. Please try again.");
                setLoading(false);
            }
        };

        fetchOffers();
    }, [number]);

    // Parse API data into our Category and Product models
    const parseApiData = (data) => {
        // Create a map to store categories by ID to avoid duplicates
        const categoriesMap = new Map();
        const validPictos = ["Dh", "*33","*1", "*2", "*3", "*4", "*6"];
        
        // Process each item in the response
        data.forEach(item => {
            // Create a product object
            const product = new Product(
                item.productId,
                item.productName,
                item.pricing?.finalPrice || 0,
                item.ProductSpecs?.validity || 0
            );
            if(item.categories != null) {
            // Process categories for this product
            item.categories.forEach(categoryResponse => {
                // Only include categories with valid picto values
                if (categoryResponse.picto_text != "*9" && categoryResponse.catName.includes("Recharge") && !categoryResponse.catName.includes("Dealer")) {
                    // Get existing category or create new one
                    let category = categoriesMap.get(categoryResponse.catId);
                    
                    if (!category) {
                        category = new CategoryModel(
                            categoryResponse.catId,
                            categoryResponse.catName,
                            categoryResponse.picto_text,
                            []
                        );
                        categoriesMap.set(categoryResponse.catId, category);
                    }
                    
                    // Clone the product to avoid modifying the original
                    const productForCategory = { ...product };
                    
                    // Modify product name to include the category's picto
                    productForCategory.offer = productForCategory.productName;
                    productForCategory.productName = category.picto;
                    // Add the modified product to the category
                    category.products.push(productForCategory);
                }
            });
        }
        });
        
        // Convert map to array and sort by picto
        return Array.from(categoriesMap.values())
            .sort((a, b) => a.picto.localeCompare(b.picto));
    };

    if (loading) return <Spinner overlay={true} textContent="جاري التحميل..." />;
    if (error) return <div className="container" dir="rtl">خطأ: {error}</div>;

    return (
        <div className="container" dir="rtl">
            <h1>العروض للرقم {number}</h1>
            {categories.length === 0 ? (
                <p>لا توجد عروض متاحة لهذا الرقم.</p>
            ) : (
                <>
                    <div className="categories-list">
                        {categories.map(category => (
                            <Category 
                                key={category.catId} 
                                category={category}
                                isExpanded={expandedCategoryId === category.catId}
                                onToggleExpand={handleToggleExpand}
                                selectedProductId={selectedProductId}
                                onSelectProduct={handleSelectProduct}
                            />
                        ))}
                    </div>
                    
                    {selectedProduct && (
                        <div className="selected-product-summary" style={{ textAlign: 'center' }}>
                            <h3>العرض المختار</h3>
                            <div className="summary-details">
                                <p>{selectedProduct.finalPrice} درهم {selectedProduct.productName} {number.replace("212","0")}</p>
                            </div>
                            <button 
                                className="purchase-button"
                                onClick={handlePurchase}
                                disabled={(limit && !balance.isNaN && !limit.isNaN && limit != 0 && limit - balance < selectedProduct.finalPrice)}
                            >
                                {limitReached ? "الحد الأقصى للرصيد تم الوصول إليه" :  (limit && rest !== 0 && limit !== 0 && rest < selectedProduct.finalPrice) ? "لا يوجد رصيد كافي لاجراء العملية ، متبقي "+ rest +" ثمن العملية : " + selectedProduct.finalPrice  : "شراء هذا العرض"}
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default Offers;